import { Outlet } from "react-router-dom";
import { Drawer, Button } from "antd";
import { Menu } from "lucide-react";
import { useState } from "react";
import AdminSidebar from "./AdminSidebar";

export default function AdminLayout() {
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-[#f8f9ff] min-h-screen">
      {/* Desktop Sidebar */}
      <div className="hidden lg:block fixed left-0 top-0 h-screen w-[260px]">
        <AdminSidebar />
      </div>

      {/* Mobile Topbar */}
      <div className="lg:hidden sticky top-0 z-40 bg-white border-b px-4 py-3 flex items-center justify-between">
        <h2 className="font-extrabold text-xl m-0">ShipLess AI</h2>

        <Button
          icon={<Menu size={20} />}
          onClick={() => setOpen(true)}
        />
      </div>

      {/* Mobile Drawer */}
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        placement="left"
        width={260}
        bodyStyle={{ padding: 0 }}
        closable={false}
      >
        <AdminSidebar onMenuClick={() => setOpen(false)} />
      </Drawer>

      {/* Content */}
      <main className="lg:ml-[260px] min-w-0 p-4 md:p-6 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}